/**
 * Converts a base64 string to an ArrayBuffer.
 *
 * @param base64 - A base64 encoded string that needs to be converted to an ArrayBuffer.
 * @returns An ArrayBuffer containing the decoded binary data from the base64 input.
 * @throws Will throw an error if the input is not a valid base64 string or if decoding fails.
 */
export function base64ToArrayBuffer(base64: string): ArrayBuffer {
    try {
        // If the base64 string has a data URL prefix, remove it
        const base64String = base64.includes(',') ? base64.split(',')[1] : base64;

        // Decode the base64 string to a binary string
        const binaryString: string = atob(base64String);

        const len: number = binaryString.length;
        const bytes: Uint8Array = new Uint8Array(len);

        // Convert each character in the binary string to its char code
        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }

        return bytes.buffer as ArrayBuffer;
    } catch (error) {
        console.error('Invalid base64 string:', error);
        throw new Error('Failed to convert base64 to ArrayBuffer.');
    }
}